import React from "react";

import { AmphoreProvider } from "@amphore-dev/amphore-lib";
import "@amphore-dev/amphore-lib/lib/style.css";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useTranslation } from "react-i18next";
import { ToastContainer } from "react-toastify";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
//devtools
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import { AuthProvider } from "@/contexts/AuthContext/AuthContext";

import { libLocaleFor, syncDateLocaleWithLanguage } from "@/i18n/dateLocale";
import { syncManifestWithLanguage } from "@/i18n/manifest";

import { ContextMenusProvider, ModalProvider } from "./contexts";
import Router from "./router/Router";

syncDateLocaleWithLanguage();
syncManifestWithLanguage();

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			retry: 1,
		},
	},
});

gsap.registerPlugin(ScrollTrigger);

export const App = () => {
	// useTranslation re-renders on languageChanged: the lib labels follow.
	const { i18n } = useTranslation();

	return (
		<AmphoreProvider
			locale={libLocaleFor(i18n.language)}
			config={{
				colors: {
					primary: "#0383d3",
				},
			}}
		>
			<QueryClientProvider client={queryClient}>
				<AuthProvider>
					<ModalProvider>
						<ContextMenusProvider>
							<Router />
							<ToastContainer
								hideProgressBar
								pauseOnHover={false}
								closeOnClick
								limit={5}
							/>
						</ContextMenusProvider>
					</ModalProvider>
				</AuthProvider>
				<ReactQueryDevtools initialIsOpen={false} />
			</QueryClientProvider>
		</AmphoreProvider>
	);
};
